import { Node, mergeAttributes } from "@tiptap/core";
import { Plugin } from "prosemirror-state";

const CustomImage = Node.create({
  name: "image",
  group: "block",
  draggable: true,
  selectable: true,
  inline: false,

  addAttributes() {
    return {
      src: { default: null },
      alt: { default: null },
      title: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: "img[src]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["img", mergeAttributes(HTMLAttributes)];
  },

  addProseMirrorPlugins() {
    const uploadUrl = "https://digital.tifleducation.com/admin/public/api/uploadQuestionImage";
    const token = localStorage.getItem("token");

    const uploadImage = async (file, view) => {
      const formData = new FormData();
      formData.append("image", file);

      try {
        const res = await fetch(uploadUrl, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        });

        const data = await res.json();
        if (data.url) {
          const { schema } = view.state;
          const node = schema.nodes.image.create({ src: data.url });
          const transaction = view.state.tr.replaceSelectionWith(node);
          view.dispatch(transaction);
        }
      } catch (err) {
        console.error("Image upload failed", err);
      }
    };

    return [
      new Plugin({
        props: {
          handlePaste: (view, event) => {
            const items = event.clipboardData?.items;
            if (!items) return false;

            for (const item of items) {
              if (item.type.startsWith("image/")) {
                const file = item.getAsFile();
                uploadImage(file, view); // ✅ pass view
                return true;
              }
            }
            return false;
          },

          handleDrop: (view, event) => {
            const files = event.dataTransfer?.files;
            if (!files?.length) return false;

            [...files].forEach((file) => {
              if (file.type.startsWith("image/")) {
                uploadImage(file, view); // ✅ pass view
              }
            });
            return true;
          },
        },
      }),
    ];
  },
});

export default CustomImage;
